<template>
  <div class="cp-set-shop-name main">
    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-store-alt icon" />Shop Name</p>
      <div style="margin-top: 10px">
        <input class="input" v-model="shopName" />
      </div>
      <div class="save-wrapper">
        <p v-if="updatingShopName" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveShopName">Save</p>
      </div>
    </div>

    <div v-if="$store.getters.isSuperUser" class="superuser">
      <div class="divider" />

      <div class="row">
        <p><i class="fa fa-language icon" />Alternate Names</p>
        <div style="margin-top: 10px">
          <textarea
            class="textarea"
            v-model="alternateNames"
            placeholder="{ 'en': 'English Name', 'th': 'Thai Name', 'ja': 'Japanese Name' }"
            rows="3"
          />
        </div>
        <div class="save-wrapper">
          <p v-if="updatingAlternateNames" class="button">
            <i class="fa fa-spinner fa-spin" />
          </p>
          <p v-else class="button has-text-success" @click="saveAlternateNames">
            Save
          </p>
        </div>
      </div>

      <div class="divider" />

      <div class="row">
        <p><i class="fa fa-tags icon" />Search Terms</p>
        <div style="margin-top: 10px">
          <input
            class="input"
            v-model="searchTerms"
            placeholder="Search terms..."
          />
        </div>
        <div class="save-wrapper">
          <p v-if="updatingSearchTerms" class="button">
            <i class="fa fa-spinner fa-spin" />
          </p>
          <p v-else class="button has-text-success" @click="saveSearchTerms">
            Save
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetShopName",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      shopName: null,
      updatingShopName: false,
      searchTerms: null,
      alternateNames: null,
      updatingSearchTerms: false,
      updatingAlternateNames: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    languages() {
      return this.commerce.data.languages || ["en", "th"]; // otherwise show default languages...
    },
  },
  mounted() {
    this.shopName = this.business.name;
    this.searchTerms = this.business.data.search_terms;
    this.alternateNames = this.business.data.alternate_names;
  },
  methods: {
    saveShopName() {
      if (!this.shopName || this.shopName.length < 5) {
        var msg = "Shop name is too short";
        this.errorToast(msg, "top");
        return;
      }
      if (this.shopName === this.business.name) {
        msg = "Shop name hasn't changed";
        this.infoToast(msg);
        return;
      }
      var obj = { id: this.business.id, name: this.shopName };
      this.updatingShopName = true;
      this.$store
        .dispatch("updateBusiness", obj)
        .then(() => {
          this.successToast("Updated!");
          this.business.name = this.shopName; // set it locally
          // or better, update the whole business
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingShopName = false));
    },
    saveSearchTerms() {
      // if (!this.searchTerms) return;
      var data = { search_terms: this.searchTerms };
      this.updatingSearchTerms = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: data,
        })
        .then((res) => {
          this.successToast("Updated search terms");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingSearchTerms = false));
    },
    saveAlternateNames() {
      if (!this.$h.isValidJSON(this.alternateNames)) {
        var msg = `Invalid JSON! Try:<br>{"th": "Thai Name", "en": "English Name"}`;
        this.errorToast(msg, "top", 10000);
        return;
      }
      var data = { alternate_names: this.alternateNames };
      this.updatingAlternateNames = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: data,
        })
        .then((res) => {
          this.successToast("Updated search terms");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingAlternateNames = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.superuser .row {
  background-color: #eef;
}
</style>
